'use strict';
angular.module('schoolLinqApp').directive('searchImageTextbox', [
	'$browser',
	'$timeout',
	function ($browser, $timeout) {
		return {
			scope: {
				ngModel: '=ngModel',
				textboxClass: '@',
				containerClass: '@',
				debounceWait: '@',
				autocomplete: '@',
				changeCallback: '&',
				trigger: '@focus',
				disabled: '@disabled',
				inputId: '@',
			},
			require: 'ngModel',
			replace: true,
			restrict: 'E',
			template: `<div class="searchImageTextBoxContainer {{containerClass}}">
				<input type="text" class="{{textboxClass}}" id="{{inputId}}" ng-model="ngModel" no-dirty autocomplete="{{autocomplete}}" />
				<i id="removeSearch" class="fa fa-times-circle fa-lg remove" ng-show="ngModel" ng-click="ngModel=''" aria-hidden="true"></i>
			</div>`,
			link: function ($scope, elem, attr, ngModelCtrl) {
				var listener = function () {
					if ($scope.changeCallback) {
						$scope.changeCallback();
					}
				};

				const inputElement = $(elem).find('input');
				inputElement.bind('keyup', _.debounce(listener, $scope.debounceWait ? $scope.debounceWait : 0));
				$(elem).find('i').bind('click', listener);

				$scope.$watch('inputId', function (value) {
					if (!value) {
						inputElement.attr('id', Math.random().toString().substr(2, 8));
					}
				});

				$scope.$watch('trigger', function (value) {
					if (value === 'true') {
						$timeout(function () {
							inputElement.focus();
						});
					}
				});

				$scope.$watch('disabled', function (value) {
					if (!_.isNull(value) && !_.isUndefined(value)) {
						inputElement.prop('disabled', value === 'true');
					}
				});

				if (!$scope.autocomplete) {
					$scope.autocomplete = 'on';
				}
			},
		};
	},
]);
